export default __webpack_public_path__ + "static/media/151-interior-design.dc2fc066.png";